<template>
  <div id="app">
    <VisualAtmosphere />
    <router-view :key="session.user ? session.user.id : 'signed-out'" />
  </div>
</template>

<script>
import { sessionMixin } from './components/shared/runtime'
import VisualAtmosphere from './components/shared/VisualAtmosphere.vue'

// 后台使用独立浅色主题，避免顾客端布局规则影响管理界面。
const CLASSIC_ROUTES = ['admin', 'gallery']

export default {
  components: { VisualAtmosphere },
  mixins: [sessionMixin],
  name: 'App',
  watch: {
    $route: { immediate: true, handler(to) { this.applyTheme(to) } },
  },
  methods: {
    applyTheme(route) {
      if (typeof document === 'undefined') return
      const customer = !!route && !CLASSIC_ROUTES.includes(route.name)
      document.documentElement.classList.toggle('lx-on', customer)
      document.documentElement.classList.toggle('admin-on', !!route && route.name === 'admin')
    },
  },
}
</script>

<style>
#app {
  font-family: var(--ui-font);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--ink);
}
</style>
